const i = {
  all: "unset",
  position: "relative",
  bg: "lightGray3",
  color: "white",
  cursor: "pointer",
  border: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "50%",
  transition: "all",
  ":focus-visible": (e) => ({
    ...e.outline()
  }),
  ":hover": {
    opacity: 0.8
  },
  ":active": {
    opacity: 1
  },
  '&[data-state="checked"]': {
    bg: "primary"
  },
  ":disabled": {
    cursor: "default",
    pointerEvents: "none",
    bg: "stroke",
    color: "secondaryText"
  }
}, n = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  backgroundColor: "white"
}, t = {
  sm: {
    size: 5
  },
  md: {
    size: 6
  },
  lg: {
    size: 8
  }
}, o = {
  sm: {
    size: 2
  },
  md: {
    size: (e) => e.spacing(2.5)
  },
  lg: {
    size: 3
  }
}, r = {
  radioButtonSizes: t,
  radioButtonIndicatorSizes: o
};
export {
  n as radioButtonIndicator,
  o as radioButtonIndicatorSizes,
  i as radioButtonStyles,
  r as radioButtonTheme
};
